module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-BlackHeadline-f038448f5b2349a31391c8ad7ec70c28.woff";